import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { AccountingLayout } from '../Layout';

function AccountingTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    return (
        <FormField
            currrentUser={currentUser}
            layoutId='B8F39A88-1E2D-4C77-9848-A719A83E7F83'
            layoutName='OMTransactionprofileAccountingForm'
            defaultFormSchema={AccountingLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            handleFieldValueChange={props.handleFieldChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={props.formRefs}
            onFormLoad={props.handleAccountingFormLoad}
            handleSelectedItemChange={props.handleSelectionChange}
        />);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AccountingTab);
